import React from 'react';
import { Calendar } from 'primereact/calendar';
import { FormField } from '../../FormField/FormField';
import { ReservationFormFieldProps } from '../types';
import { getDayDisplay } from '../utils/display';

interface Props extends Omit<ReservationFormFieldProps, 'setFormFields'> {
  canModifyDate: boolean;
  showRequiredFields: boolean;
  isTouchDevice: boolean;
  locale: string;
  onChange: (day: Date) => void;
}

/** The day of the reservation. */
export const DayField = ({
  form,
  validationErrors,
  canModifyDate,
  showRequiredFields,
  isTouchDevice,
  locale,
  onChange,
}: Props) => {
  return (
    <FormField
      labelTitle='Día'
      elementId='reservation-day'
      fullWidth
      error={validationErrors?.selectedDay}
      required={showRequiredFields}
    >
      {canModifyDate ? (
        <Calendar
          inputId='reservation-day'
          value={form?.selectedDay}
          invalid={!!validationErrors?.selectedDay}
          placeholder='Selecciona fecha de la reserva'
          onChange={(e) => {
            if (e.value) {
              onChange(e.value);
            }
          }}
          showIcon
          dateFormat='dd/mm/yy'
          touchUI={isTouchDevice}
          locale={locale}
        />
      ) : (
        getDayDisplay(form?.localStartDate)
      )}
    </FormField>
  );
};
